const mixpanelConfig = {
  development: {
    token: '105eb7c0deb09c96a918433c2cf9837f'
  },
  homolog: {
    token: '105eb7c0deb09c96a918433c2cf9837f'
  },
  test: {
    token: '105eb7c0deb09c96a918433c2cf9837f'
  },
  production: {
    token: 'becc5124369260759229985159647283'
  }
}

export default mixpanelConfig[process.env.REACT_APP_NODE_ENV]
